declare var google: any;
import { Component, OnInit, NgZone } from '@angular/core';
import { DoctorService } from 'src/app/services/doctor.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { AuthService } from 'src/app/services/auth.service';

import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from 'ngx-toastr';
import { WindowreffService } from 'src/app/services/windowreff.service';

@Component({
  selector: 'app-doctor-detail',
  templateUrl: './doctor-detail.component.html',
  styleUrls: ['./doctor-detail.component.css'],
  providers:[WindowreffService]
})
export class DoctorDetailComponent implements OnInit {
  doctorDetail:any={
    review:[],
    blogs:[],
    services:[],
    membership:[],
    awards:[],
    languages:[],
    education:[],
    speciality:[]
  }
  availability:any=[]
  morningSlots:any = [] 
  afterNoonSlots:any = []
  eveningSlots:any = []
  showDateWithDay:any = []
  imageDoctor:any=[]
  loading:boolean = true
  sendBookingData:any={
    bookingDate:'',
    startTime:'',
    doctorId:'',
    treatments:[]
  }
  totalAmount:number=0
  sendTreatments:any=''
  slideConfig = {
    infinite: false,
    speed: 300,
    dots: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]

  };
  finalObj:any={
    customerDetail:{
      name:'',
      phone:'',
      email:''
    },
    cardDetail:{
      cardNumber:'',
      cardExpDate:'',
      cardCvv:'',

    },
    addressDetail:{
      address:'',
      landmark:'',
      city:'',
      state:'',
      pincode:''
    }
  }
  treatmentError:boolean=false
  startTimeError:boolean=false
  bookingDay:any='Today'
  slideConfigCustomers = {
    infinite: true,
    speed: 300,
    arrows: false,
    autoplay:true,
    dots: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  };
  constructor(public doctorSvc:DoctorService,
              public activatedRoute:ActivatedRoute,
              public datepipe: DatePipe,
              private auth:AuthService,
              private router:Router,
              private toaster: ToastrService,
              private spinner: NgxSpinnerService,
              private winRef: WindowreffService,
              private ngZone:NgZone) { }

  ngOnInit() {
    this.spinner.show();
    let date = new Date();
    let latest_date =this.datepipe.transform(date, 'dd-MM-yyyy');
    if(this.activatedRoute.snapshot.params.id)
      this.getDoctorDetail(this.activatedRoute.snapshot.params.id,latest_date)
      this.showDateswithDay()
      this.sendBookingData.doctorId = this.activatedRoute.snapshot.params.id
   
  }

  payWithRazor(){ 
    if(this.totalAmount==0){
      this.bookDoctor()
      document.getElementById('booking_doctor_trigge_doctor').click()
    }
    else{
    document.getElementById('booking_doctor_trigge_doctor').click()
    let options:any = {
        "key": "rzp_live_YmyxdRilAgKlpK",// test key :rzp_test_dvfpRNEUlLTuCq
        "amount": 5*this.totalAmount,
        "name": "Daktarz",
        "description": "Doctor Booking",
      //  "image": "./assets/images/logo.png",
        "modal": {
          "escape": false
        }, 
        "prefill": {
          "name": this.finalObj.customerDetail.name,
          "contact": this.finalObj.customerDetail.phone,
          "email": this.finalObj.customerDetail.email,
          "method": 'card',
          'card[number]': this.finalObj.cardDetail.cardNumber,
          'card[expiry]': this.finalObj.cardDetail.cardExpDate,
          'card[cvv]': this.finalObj.cardDetail.cardCvv
        },
        "notes": {
          "address": this.finalObj.addressDetail.address + ', ' + this.finalObj.addressDetail.landmark + ', ' + this.finalObj.addressDetail.city + ', ' + this.finalObj.addressDetail.state + '-' + this.finalObj.addressDetail.pincode
        },
        "theme": {
          "color": "#26abe3"
        }
      };
      options.handler = ((response) => {
        console.log(response)
          if(response.razorpay_payment_id){
            this.sendBookingData["transactionId"] = response.razorpay_payment_id
            this.bookDoctor()
          }
        // this.paymentService.payWithRazor({cart: this.finalObj, payment: options});
      });
      options.modal.ondismiss = (() => {
        //  this.loginService.SetLoader = false;
      });
      let rzp = new this.winRef.nativeWindow.Razorpay(options);
      rzp.open();
    }
  }
  getDoctorDetail(doctorId:string,date){
console.log(date)
    this.doctorSvc.getDoctorDetail(doctorId,date).subscribe(res=>{
     console.log(res)
      this.doctorDetail  = res["data"][0]


      let obj = {}
      obj["profilePicture"] = this.doctorDetail["profilePicture"]
      obj["name"] = this.doctorDetail["name"]
      obj["rating"] = this.doctorDetail["rating"]
      obj["review"] = this.doctorDetail["review"]


      localStorage.setItem('bookingDoctorInfo',JSON.stringify(obj))
      this.availabilityTiming(this.doctorDetail.timings)
      this.slotAssign(this.doctorDetail.slots,date)
     
      this.spinner.hide();
   
    },error=>{
console.log(error)
    })

  }
  showImagePopup(image){
    this.imageDoctor=[]
    this.imageDoctor.push(image)
    document.getElementById('orderImagesCLick').click()
  }
  getSlots(object,index){
 this.sendBookingData.bookingDate = object.sendDate
    this.showDateWithDay.map(showday=>{
      showday.selected = false
    })
    this.showDateWithDay[index].selected =true
    this.getDoctorDetail( this.activatedRoute.snapshot.params.id,object.sendDate)
    this.bookingDay = object.day=='Today' ? this.datepipe.transform(object.sendDate,'E') : object.day 
  }
  getPriceAfterDiscount(price,discount){
 let priceTemp =  price-(price*discount/100)
 
    return priceTemp==0 ? 'Free' : price-(price*discount/100)
  }
  getPriceAfterDiscount1(price,discount){
    let priceTemp =  price-(price*discount/100)
    
       return priceTemp
     }


  scroll(el: HTMLElement) {
    el.scrollIntoView();
}
availabilityTiming(timing){
  this.availability=[]
  let lengthTimings  =timing.length

  for(let i=0;i<lengthTimings;i++){
    if(!timing[i].startTime || !timing[i].endTime){

    }
    else if(this.tConvert(timing[i].startTime)==this.tConvert(timing[i].endTime)){
      this.availability.push({timing:timing[i].showDay!=null ? timing[i].showDay+' | ' + this.tConvert(timing[i].startTime)+' - '+this.tConvert(timing[i].endTime) :  this.tConvert(timing[i].startTime)+' - '+this.tConvert(timing[i].endTime),error:false})
    }
    else{
   
    this.availability.push({timing:timing[i].showDay!=null ? timing[i].showDay+' | ' + this.tConvert(timing[i].startTime)+' - '+this.tConvert(timing[i].endTime) :  this.tConvert(timing[i].startTime)+' - '+this.tConvert(timing[i].endTime),error:false})
    }
  }
      
}
slotAssign(slots,date){
  this.morningSlots = []
  this.afterNoonSlots = []
  this.eveningSlots = []
  console.log(new Date().getHours())

slots.map(slot=>{
  this.assignSlotsEach(slot.time,slot.status,date)
  
 // this.assignSlotsEach(slot.time,false,date) // for testing
})


}
showDateswithDay(){
  this.showDateWithDay=[]
  var currentDate = new Date();
  let latest_date =this.datepipe.transform(currentDate, 'dd-MM-yyyy');
  this.sendBookingData.bookingDate = latest_date
  this.showDateWithDay.push({ selected:true,sendDate:this.datepipe.transform(currentDate,'dd-MM-yyyy') ,day:'Today',showdate:this.datepipe.transform(currentDate,'dd 	LLL') })
    let i=1
    while(i<4){
    currentDate.setDate(currentDate.getDate() + 1);
    this.showDateWithDay.push({ selected:false,sendDate:this.datepipe.transform(currentDate,'dd-MM-yyyy') ,day:this.datepipe.transform(currentDate,'E'),showdate:this.datepipe.transform(currentDate,'dd 	LLL') })
    i++
    }
  
}
counter(i: number) {
  return new Array(i);
}
assignSlotsEach(time,status,date){
  let time1 = time.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
  let time2:any
  

  if (time1.length > 1) { // If time format correct
     time2 = time1.slice (1);  // Remove full string match value
    time2[5] = +time2[0] < 12 ? ' am' : ' pm'; // Set AM/PM
    time2[0] = +time2[0] % 12 || 12; // Adjust hours
  }
  
 
 if(time2[0]<=12 && time2[5]==' am'){
  this.morningSlots.push({time:time2.join(''),status:status,sendTime:time,selected:false})
//    if(date==this.datepipe.transform(new Date(),'dd-MM-yyyy') ){
//     if(new Date().getHours()>=parseInt(time.split(':')[0]))
//     {
//       this.morningSlots.push({time:time2.join(''),status:true,sendTime:time,selected:false})
//     }
//     else{
//       this.morningSlots.push({time:time2.join(''),status:status,sendTime:time,selected:false})
//     }
//    }

//   else {
//     this.morningSlots.push({time:time2.join(''),status:status,sendTime:time,selected:false})
  
//  }
}

 if( (time2[0]==1 || time2[0]==2 || time2[0]==3 || time2[0]==12) && time2[5]==' pm'){
  this.afterNoonSlots.push({time:time2.join(''),status:status,sendTime:time,selected:false})
   //console.log(time2)
  //  if(date==this.datepipe.transform(new Date(),'dd-MM-yyyy') ){
  //   if(new Date().getHours()>=parseInt(time.split(':')[0]))
  // {
  //   this.afterNoonSlots.push({time:time2.join(''),status:true,sendTime:time,selected:false})
  // }
  // else{
  // this.afterNoonSlots.push({time:time2.join(''),status:status,sendTime:time,selected:false})
  // }
  // }
  // else{
  //   this.afterNoonSlots.push({time:time2.join(''),status:status,sendTime:time,selected:false})
  // }
  
}
if(time2[0]<12 && time2[0]>=4  && time2[5]==' pm'){
  this.eveningSlots.push({time:time2.join(''),status:status,sendTime:time,selected:false})
  // if(date==this.datepipe.transform(new Date(),'dd-MM-yyyy') )
  // {
  //   if(new Date().getHours()>=parseInt(time.split(':')[0]))
  // {
  //   this.eveningSlots.push({time:time2.join(''),status:true,sendTime:time,selected:false})
  // }
  // else{
  //   this.eveningSlots.push({time:time2.join(''),status:status,sendTime:time,selected:false})
  // }
  // }
  // else{
  //   this.eveningSlots.push({time:time2.join(''),status:status,sendTime:time,selected:false})
  // }
 


}

}
 tConvert (time) {
  // Check correct time format and split into components

  let time1 = time.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
let time2:any

  if (time1.length>1) { // If time format correct
     time2 = time1.slice (1);  // Remove full string match value
    time2[5] = +time2[0] < 12 ? ' am' : ' pm'; // Set AM/PM
    time2[0] = +time2[0] % 12 || 12; // Adjust hours
  }
  else{

  }
  //console.log(time2)
 return  time2.join ('') // return adjusted time or original string
}

Booking(flag){
  if(this.sendBookingData.startTime==''){
    this.startTimeError=true
    this.treatmentError =false
    document.getElementById('slot_popup_trigge_doctor').click()
  }
  else if(this.sendBookingData.treatments.length==0){
    this.treatmentError=true
    this.startTimeError=false
    document.getElementById('treatment_popup_trigge_doctor').click()
  }
   
  else
  {
    if(!flag){
     document.getElementById('treatment_popup_trigge_doctor').click()
    }
    this.startTimeError=false
    this.treatmentError =false


  let token =localStorage.getItem('token')
  let usertype =localStorage.getItem('usertype')
  if(token!=null && usertype=='User'){
    this.sendTreatments =  this.sendBookingData.treatments.map(e => e.name).join(",");
    this.totalAmount =  this.sendBookingData.treatments.reduce( 
      (a: number, b) => a + b.price, 0);

  document.getElementById('booking_doctor_trigge_doctor').click()


    
  }
    
  else{
    this.sendTreatments =  this.sendBookingData.treatments.map(e => e.name).join(",");
        this.totalAmount =  this.sendBookingData.treatments.reduce( 
          (a: number, b) => a + b.price, 0);
    localStorage.setItem('doctorBookingData',JSON.stringify(this.sendBookingData))
    document.getElementById('logintoggle_user').click()
  }
}

  console.log(this.sendBookingData)
}
bookDoctor(){
  this.auth.doctorBooking(this.sendBookingData).subscribe(res=>{
    console.log('here')
    localStorage.setItem('tab','doctors')
    //document.getElementById('booking_doctor_trigge_doctor').click()
    this.ngZone.run(()=>this.navigateTo('/user-orders'));
   
    
  },error=>{
    this.toaster.error(error.error.message, '', {
      timeOut: 2000
    });
    console.log(error)
  }) 
}
navigateTo(url){
  this.router.navigate([url])
}

onCheckboxChange(option, event) {
  
  if(event.target.checked) {
    this.treatmentError=false
    console.log(option)
    let obj={treatmentId:option._id,name:option.name,price:this.getPriceAfterDiscount1(option.price,this.doctorDetail.discount)}
    
    this.sendBookingData.treatments.push(obj);
  } else {
  for(var i=0 ; i < this.sendBookingData.treatments.length; i++) {
    if(this.sendBookingData.treatments[i].treatmentId == option._id) {
      this.sendBookingData.treatments.splice(i,1);
   }
 }


}
console.log(this.sendBookingData)



}
timeSet(status,time,slot){
  if(!status){
    this.afterNoonSlots.map(slot=>slot.selected=false)
    this.morningSlots.map(slot=>slot.selected=false)
    this.eveningSlots.map(slot=>slot.selected=false)

    slot.selected =true
    this.sendBookingData.startTime = time
 
  }
  else
    console.log('disabled')
}
findAlreadyAdded(record){

  let check = this.sendBookingData.treatments.findIndex(treatment=>treatment.treatmentId==record._id)

if(check>-1){
  return true

}
else{
  return false
}
}
showTreatPopup(){
  document.getElementById('slot_popup_trigge_doctor').click()
  document.getElementById('treatment_popup_trigge_doctor').click()
}
closeSlotPopup(){
  document.getElementById('slot_popup_trigge_doctor').click()
}
parseInt(number){
  return parseInt(number)
}
}
